// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.view-iybr-wrapper {
  margin: 1.6rem 3.2rem 3.2rem;
  padding-bottom: 6.4rem;
}
.view-iybr-wrapper .pui-breadcrumb-item--is-first .pui-breadcrumb-item__link {
  padding-left: 0;
}
.view-iybr-wrapper .iybr-headline {
  margin-top: 1.6rem;
  margin-bottom: 2.4rem;
}
.view-iybr-wrapper .separator {
  height: 1px;
  width: 100%;
  background-color: #cdcdcd;
}
.view-iybr-wrapper .vertical-separator {
  height: 1.6rem;
  width: 1px;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
  background-color: #cdcdcd;
}
.view-iybr-wrapper .approver-item {
  display: flex;
  flex-direction: column;
  width: calc(25% - 1.6rem);
}
.view-iybr-wrapper .non-reviewers-list {
  display: flex;
}
.view-iybr-wrapper .non-reviewer + .non-reviewer {
  margin-left: 2vh;
}
.view-iybr-wrapper .heading-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.view-iybr-wrapper .approver-item-container {
  align-items: start;
  flex-wrap: wrap;
  justify-content: start;
  gap: 1.6rem;
}
.view-iybr-wrapper .subheading-flex {
  display: flex;
  flex-direction: row;
}
.view-iybr-wrapper .text-bolded {
  font-weight: bold;
}
.view-iybr-wrapper .menu-details {
  margin-bottom: 3.84rem;
}
.view-iybr-wrapper a.menu-details {
  font-weight: bold;
  color: #0059a4;
}
.view-iybr-wrapper a.menu-details:hover {
  text-decoration: none;
}
.view-iybr-wrapper .menu-details.history {
  color: #cdcdcd;
  cursor: pointer;
}
.view-iybr-wrapper .menu-details.tab-active {
  padding-bottom: 5px;
  border-bottom: 2px solid #0059a4;
  cursor: pointer;
}
.view-iybr-wrapper .menu-details.tab-active:hover,
.view-iybr-wrapper .menu-details.history:hover {
  color: #0059a4;
}
.view-iybr-wrapper .linked-global-ids__value--ellipsis {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
